import { FormControl, FormGroup } from '@angular/forms';
import {
    type AnimationSettingsFormControls,
    EAnimationPosition,
    EAnimationSpeed,
    EAnimationType,
} from '../type/animation-settings.type';

type Params = {
    isActive?: boolean;
    animationType?: EAnimationType;
    animationPosition?: EAnimationPosition;
    animationSpeed?: EAnimationSpeed;
};
const defaultParams: Params = {
    isActive: false,
    animationType: EAnimationType.fade,
    animationPosition: EAnimationPosition.left,
    animationSpeed: EAnimationSpeed.medium,
};
export function animationSettingsFormGroup({
    isActive = defaultParams.isActive,
    animationType = defaultParams.animationType,
    animationPosition = defaultParams.animationPosition,
    animationSpeed = defaultParams.animationSpeed,
}: Params = {}): FormGroup<AnimationSettingsFormControls> {
    return new FormGroup<AnimationSettingsFormControls>({
        isActive: new FormControl(isActive),
        animationType: new FormControl(animationType),
        animationPosition: new FormControl(animationPosition),
        animationSpeed: new FormControl(animationSpeed),
    });
}
